export default function <T>(obj: T): T {
  if (typeof obj !== "object") return obj;
  return JSON.parse(JSON.stringify(obj));
}
